import { useGetLocationBusinessHoursQuery, useCreateBusinessHoursMutation, useUpdateBusinessHoursMutation, useDeleteBusinessHoursMutation } from '../gql/businessHours.generated';
import { DAY_NAMES } from '../utils/businessHoursUtils';

export const useBusinessHours = (locationId: string | undefined) => {
  const days = [0, 1, 2, 3, 4, 5, 6]; // Sunday-Saturday

  console.log('locationId:', locationId);
  // Query for fetching business hours
  const { data, loading, error, refetch } = useGetLocationBusinessHoursQuery({
    variables: { locationId: locationId as any },
    skip: !locationId,
  });

  // Mutations for CRUD operations
  const [createBusinessHoursMutation, { loading: creating }] = useCreateBusinessHoursMutation({
    refetchQueries: ['GetLocationBusinessHours'],
  });

  const [updateBusinessHoursMutation, { loading: updating }] = useUpdateBusinessHoursMutation({
    refetchQueries: ['GetLocationBusinessHours'],
  });

  const [deleteBusinessHoursMutation, { loading: deleting }] = useDeleteBusinessHoursMutation({
    refetchQueries: ['GetLocationBusinessHours'],
  });

  const businessHours = data?.businesshours || [];

  return {
    businessHours,
    loading,
    error,
    creating,
    updating,
    deleting,
    refetch,
    createBusinessHours: createBusinessHoursMutation,
    updateBusinessHours: updateBusinessHoursMutation,
    deleteBusinessHours: deleteBusinessHoursMutation,
    days,
    dayNames: DAY_NAMES,
  };
};
